/* Guardians theme — interactie
   Geen dependencies. Alles hangt aan data-gd-* attributen. */
(function () {
  'use strict';
  var GD = window.GD || {};
  // vertaalde teksten komen uit de taalbestanden (gd-head)
  var T = function (k, vars) {
    var t = (GD.t && GD.t[k]) || k;
    if (vars) Object.keys(vars).forEach(function (v) { t = t.split('__' + v + '__').join(vars[v]).replace(new RegExp('{{\\s*' + v + '\\s*}}', 'g'), vars[v]); });
    return t;
  };
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: currency || GD.currency || 'EUR' }).format(cents / 100);
    } catch (e) { return '€' + (cents / 100).toFixed(2).replace('.', ','); }
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function lockScroll(on) { document.documentElement.style.overflow = on ? 'hidden' : ''; }

  /* ---------------- drawers (menu + cart) ---------------- */
  var lastFocus = null;
  function openDrawer(id) {
    var d = document.getElementById(id); if (!d) return;
    // menu schuift in vanaf de kant waar de knop staat (gescrold: links)
    if (id === 'gd-menu' && header) { var left = header.classList.contains('is-scrolled'); d.classList.toggle('gd-drawer--left', left); d.classList.toggle('gd-drawer--right', !left); void d.offsetWidth; }
    lastFocus = document.activeElement;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); lockScroll(true);
    var f = d.querySelector('button, a, input'); if (f) setTimeout(function () { f.focus(); }, 50);
  }
  function closeDrawer(d) {
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); lockScroll(false);
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-gd-open]');
    if (o) { e.preventDefault(); if (o.getAttribute('data-gd-open') === 'gd-cart') { renderCart(); } openDrawer(o.getAttribute('data-gd-open')); return; }
    var c = e.target.closest('[data-gd-close]');
    if (c) { var d = c.closest('.gd-drawer, .gd-modal, .gd-lightbox'); if (d) { e.preventDefault(); d.classList.contains('gd-drawer') ? closeDrawer(d) : closeModal(d); } }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    $$('.gd-drawer.is-open').forEach(closeDrawer);
    $$('.gd-modal.is-open, .gd-lightbox.is-open').forEach(closeModal);
  });
  function openModal(m) { lastFocus = document.activeElement; m.classList.add('is-open'); lockScroll(true); var f = m.querySelector('[data-gd-close]'); if (f) f.focus(); }
  function closeModal(m) { m.classList.remove('is-open'); lockScroll(false); if (lastFocus) lastFocus.focus(); }

  /* ---------------- aankondigingsbalk (mobiel roteren) ---------------- */
  $$('[data-gd-announce]').forEach(function (bar) {
    var items = $$('.gd-announce__item', bar); if (items.length < 2) { if (items[0]) items[0].classList.add('is-active'); return; }
    var i = 0; items[0].classList.add('is-active');
    setInterval(function () { items[i].classList.remove('is-active'); i = (i + 1) % items.length; items[i].classList.add('is-active'); }, 3800);
  });

  /* ---------------- winkelwagen ---------------- */
  function cartFetch(url, body) {
    return fetch(root + url, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function setCount(n) { $$('[data-gd-cart-count]').forEach(function (el) { el.textContent = n; el.setAttribute('data-count', n); }); }

  function renderCart(cart) {
    var body = $('[data-gd-cart-body]'); if (!body) return Promise.resolve();
    var p = cart ? Promise.resolve(cart) : cartFetch('cart.js');
    return p.then(function (cart) {
      setCount(cart.item_count);
      var foot = $('[data-gd-cart-foot]');
      var threshold = parseInt(GD.freeShippingCents || 0, 10);
      var html = '';
      if (threshold > 0) {
        var left = threshold - cart.total_price;
        var pct = Math.min(100, Math.round(cart.total_price / threshold * 100));
        html += '<div class="gd-cart__progress">' + (left > 0
          ? T('cart.free_left', { amount: money(left, cart.currency) })
          : T('cart.free_done')) + '<div class="gd-cart__bar"><span style="width:' + pct + '%"></span></div></div>';
      }
      if (!cart.item_count) {
        body.innerHTML = html + '<div class="gd-cart__empty"><p class="gd-h3">' + T('cart.empty') + '</p><p class="gd-muted">' + T('cart.empty_sub') + '</p><a class="gd-btn gd-btn--dark" href="' + (GD.shopUrl || root + 'collections/all') + '">' + T('cart.to_shop') + '</a></div>';
        if (foot) foot.hidden = true;
        return;
      }
      cart.items.forEach(function (it) {
        var img = it.image ? it.image + (it.image.indexOf('?') === -1 ? '?' : '&') + 'width=200' : '';
        var opts = (it.options_with_values || []).filter(function (o) { return o.value !== 'Default Title'; }).map(function (o) { return esc(o.name) + ': ' + esc(o.value); }).join('<br>');
        html += '<div class="gd-line" data-key="' + esc(it.key) + '">' +
          (img ? '<img class="gd-line__img" src="' + esc(img) + '" alt="" width="76" height="76" loading="lazy">' : '<span class="gd-line__img"></span>') +
          '<div><a class="gd-line__title" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
          (opts ? '<div class="gd-line__meta">' + opts + '</div>' : '') +
          '<div class="gd-qty"><button type="button" data-gd-qty="-1" aria-label="' + T('cart.less') + '">−</button><input type="number" min="0" value="' + it.quantity + '" aria-label="' + T('cart.qty') + '" data-gd-qty-input><button type="button" data-gd-qty="1" aria-label="' + T('cart.more') + '">+</button></div>' +
          '<br><button type="button" class="gd-line__remove" data-gd-remove>' + T('cart.remove') + '</button></div>' +
          '<div class="gd-line__price">' + money(it.final_line_price, cart.currency) + '</div></div>';
      });
      // upsell: gripsokken bij sleeves (brandbook: "ideaal als actieproduct bij de sleeves")
      var up = GD.upsell;
      var free = !!(up && up.qualifiers && up.qualifiers.length && cart.items.some(function (i) { return up.qualifiers.indexOf(i.product_id) > -1; }));
      if (up && up.variantId && !cart.items.some(function (i) { return i.product_id === up.productId; })) {
        html += '<div class="gd-upsell">' + (up.image ? '<img src="' + esc(up.image) + '" alt="" loading="lazy">' : '<span></span>') +
          '<div><div class="gd-label gd-label--steel" style="font-size:10px">' + esc(free && up.label ? up.label : T('cart.upsell')) + '</div><strong style="display:block;line-height:1.2">' + esc(up.title) + '</strong><span class="gd-muted" style="font-size:14px">' + (free ? '<s>' + esc(up.price) + '</s> <b style="color:var(--gd-charcoal)">' + T('cart.free') + '</b>' : esc(up.price)) + '</span></div>' +
          '<button type="button" class="gd-btn gd-btn--dark" data-gd-upsell="' + up.variantId + '">' + T('cart.add') + '</button></div>';
      }
      body.innerHTML = html;
      if (foot) {
        foot.hidden = false;
        var t = $('[data-gd-cart-total]', foot); if (t) t.textContent = money(cart.total_price, cart.currency);
      }
    });
  }
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-gd-qty]'), r = e.target.closest('[data-gd-remove]'), u = e.target.closest('[data-gd-upsell]');
    if (q || r) {
      var line = e.target.closest('.gd-line'); var input = $('[data-gd-qty-input]', line);
      var qty = r ? 0 : Math.max(0, parseInt(input.value, 10) + parseInt(q.getAttribute('data-gd-qty'), 10));
      line.style.opacity = '.5';
      cartFetch('cart/change.js', { id: line.getAttribute('data-key'), quantity: qty }).then(renderCart);
    }
    if (u) {
      u.disabled = true;
      cartFetch('cart/add.js', { items: [{ id: parseInt(u.getAttribute('data-gd-upsell'), 10), quantity: 1 }] }).then(function () { return renderCart(); });
    }
  });
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-gd-qty-input]')) return;
    var line = e.target.closest('.gd-line');
    cartFetch('cart/change.js', { id: line.getAttribute('data-key'), quantity: Math.max(0, parseInt(e.target.value, 10) || 0) }).then(renderCart);
  });

  /* ---------------- quick add vanaf kaart ---------------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-gd-quickadd]'); if (!b) return;
    e.preventDefault(); b.setAttribute('aria-disabled', 'true');
    cartFetch('cart/add.js', { items: [{ id: parseInt(b.getAttribute('data-gd-quickadd'), 10), quantity: 1 }] })
      .then(function () { return renderCart(); }).then(function () { openDrawer('gd-cart'); })
      .catch(function () { window.location = b.getAttribute('href'); })
      .finally(function () { b.removeAttribute('aria-disabled'); });
  });

  /* ---------------- productpagina ---------------- */
  $$('[data-gd-product]').forEach(initProduct);

  function sizeCode(v) {
    var w = String(v).trim().split(/[\s(]/)[0].toUpperCase();
    return ({ SMALL: 'S', MEDIUM: 'M', LARGE: 'L', KIDS: 'KIDS', KINDERMAAT: 'KIDS' })[w] || w;
  }
  function optionKind(name) {
    var n = name.toLowerCase();
    if (/sok|sock/.test(n)) return 'sock';
    if (/scheenbeschermer|shin|guard/.test(n) && !/sleeve/.test(n)) return 'guard';
    if (/sleeve|maat|size/.test(n)) return 'sleeve';
    return null;
  }

  function initProduct(el) {
    var data = JSON.parse($('[data-gd-product-json]', el).textContent);
    var cfg = data.advisor || {};
    var form = $('[data-gd-form]', el);
    var idInput = $('input[name="id"]', form);
    var btn = $('[data-gd-atc]', el), btnLabel = $('[data-gd-atc-label]', el), msg = $('[data-gd-atc-msg]', el);
    var priceEl = $('[data-gd-price]', el), stockEl = $('[data-gd-stock]', el);
    var sticky = $('[data-gd-sticky]'), stickyBtn = sticky && $('[data-gd-sticky-btn]', sticky), stickySub = sticky && $('[data-gd-sticky-sub]', sticky);
    var groups = $$('[data-gd-option]', el);

    function selected() { return groups.map(function (g) { var c = $('input:checked', g); return c ? c.value : null; }); }
    function findVariant(sel) {
      return data.variants.filter(function (v) { return v.options.every(function (o, i) { return sel[i] === o; }); })[0];
    }
    function update(pushUrl) {
      var sel = selected();
      // beschikbaarheid per waarde, gegeven de andere keuzes
      groups.forEach(function (g, gi) {
        $$('.gd-size', g).forEach(function (s) {
          var val = $('input', s).value;
          var ok = data.variants.some(function (v) { return v.options[gi] === val && v.available && v.options.every(function (o, i) { return i === gi || !sel[i] || sel[i] === o; }); });
          s.classList.toggle('is-unavailable', !ok);
        });
        var chosen = $('[data-gd-chosen]', g); if (chosen) chosen.textContent = sel[gi] ? sel[gi].split(' (')[0] : T('product.pick_size');
      });
      var missing = sel.indexOf(null) !== -1;
      var v = missing ? null : findVariant(sel);
      if (missing) {
        btnLabel.textContent = groups.length > 1 ? T('common.choose_sizes') : T('common.choose_size');
        btn.setAttribute('aria-disabled', 'true'); idInput.value = '';
      } else if (!v || !v.available) {
        btnLabel.textContent = T('common.sold_out'); btn.setAttribute('aria-disabled', 'true'); idInput.value = '';
      } else {
        btnLabel.textContent = T('common.add_to_cart'); btn.removeAttribute('aria-disabled'); idInput.value = v.id;
      }
      var show = v || data.variants[0];
      if (priceEl) priceEl.innerHTML = money(show.price) + (show.compare_at_price > show.price ? '<s>' + money(show.compare_at_price) + '</s>' : '');
      if (stockEl) {
        if (v && !v.available) { stockEl.dataset.state = 'out'; stockEl.textContent = T('product.out_size'); }
        else if (v && v.qty > 0 && v.qty <= 5 && v.managed) { stockEl.dataset.state = 'low'; stockEl.textContent = T('product.low_stock', { count: v.qty }) + ' ' + (GD.deliveryShort || ''); }
        else { stockEl.dataset.state = 'in'; stockEl.textContent = T('product.in_stock') + ' ' + (GD.deliveryShort || ''); }
      }
      if (sticky) {
        stickySub.textContent = v ? sel.map(sizeCode).join(' · ') + ' — ' + money(v.price) : money(show.price);
        stickyBtn.textContent = missing ? T('common.choose_size') : (v && v.available ? T('common.add_to_cart') : T('common.sold_out'));
      }
      if (pushUrl && v && window.history.replaceState) {
        var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString());
      }
      if (v && v.image_index != null) goToSlide(el, v.image_index);
    }
    groups.forEach(function (g) { g.addEventListener('change', function () { $$('.gd-size', g).forEach(function (s) { s.classList.remove('is-recommended'); }); update(true); }); });
    update(false);

    function pulseMissing() {
      var sel = selected(); var gi = sel.indexOf(null);
      var target = gi !== -1 ? groups[gi] : groups[0];
      if (!target) return;
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      target.animate && target.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(-6px)' }, { transform: 'translateX(6px)' }, { transform: 'translateX(0)' }], { duration: 300 });
      msg.dataset.state = 'error'; msg.textContent = T('product.pick_first');
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (btn.getAttribute('aria-disabled') === 'true') { if (!idInput.value && selected().indexOf(null) !== -1) pulseMissing(); return; }
      msg.textContent = ''; btn.setAttribute('aria-disabled', 'true'); btnLabel.textContent = T('product.adding');
      var qty = parseInt(($('[name="quantity"]', form) || {}).value || 1, 10);
      cartFetch('cart/add.js', { items: [{ id: parseInt(idInput.value, 10), quantity: qty }] })
        .then(function () { return renderCart(); })
        .then(function () { openDrawer('gd-cart'); })
        .catch(function (err) { msg.dataset.state = 'error'; msg.textContent = (err && err.description) || T('product.add_error'); })
        .finally(function () { update(false); });
    });
    if (stickyBtn) stickyBtn.addEventListener('click', function () {
      if (selected().indexOf(null) !== -1) { pulseMissing(); return; }
      form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true }));
    });
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { sticky.classList.toggle('is-visible', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe(btn);
    }

    /* ---- maatadvies ---- */
    var adv = $('[data-gd-advisor]', el);
    if (adv) {
      var mode = 'weight';
      var result = $('[data-gd-advisor-result]', adv);
      $$('[data-gd-mode]', adv).forEach(function (b) {
        b.addEventListener('click', function () {
          mode = b.getAttribute('data-gd-mode');
          $$('[data-gd-mode]', adv).forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
          $$('[data-gd-field-mode]', adv).forEach(function (f) { f.hidden = f.getAttribute('data-gd-field-mode') !== mode; });
          compute();
        });
      });
      $$('input', adv).forEach(function (i) { i.addEventListener('input', compute); });

      function between(x, list) { // list: [[max, code], ...] oplopend
        for (var i = 0; i < list.length; i++) { if (x < list[i][0]) return list[i][1]; }
        return list[list.length - 1][1];
      }
      function compute() {
        var recs = [], out = [];
        groups.forEach(function (g, gi) {
          var kind = optionKind(data.options[gi]); var code = null;
          var values = $$('input', g).map(function (i) { return i.value; });
          var has = function (c) { return values.some(function (v) { return sizeCode(v) === c; }); };
          if (kind === 'sleeve') {
            if (mode === 'kids') code = has('KIDS') ? 'KIDS' : 'XS';
            else if (mode === 'calf') { var c = parseFloat(($('[data-gd-in="calf"]', adv) || {}).value); if (c > 0) code = between(c, [[30, 'XS'], [40, 'S'], [50, 'M'], [999, 'L']]); }
            else { var w = parseFloat(($('[data-gd-in="weight"]', adv) || {}).value); if (w > 0) code = between(w, [[cfg.w1 || 70, 'XS'], [cfg.w2 || 85, 'S'], [cfg.w3 || 95, 'M'], [999, 'L']]); }
            if (code === 'XS' && !has('XS') && has('KIDS')) code = 'KIDS';
          } else if (kind === 'guard') {
            var h = parseFloat(($('[data-gd-in="height"]', adv) || {}).value);
            if (h > 0) code = between(h, [[cfg.h1 || 150, 'S'], [cfg.h2 || 175, 'M'], [999, 'L']]);
          } else if (kind === 'sock') {
            var s = parseFloat(($('[data-gd-in="shoe"]', adv) || {}).value);
            if (s > 0) code = between(s, [[38, 'S'], [44, 'M'], [999, 'L']]);
          }
          $$('.gd-size', g).forEach(function (sz) { sz.classList.remove('is-recommended'); });
          if (code) {
            var match = $$('input', g).filter(function (i) { return sizeCode(i.value) === code; })[0];
            if (match) {
              match.checked = true; match.closest('.gd-size').classList.add('is-recommended');
              out.push('<b>' + esc(data.options[gi].replace(/ maat$/i, '')) + ': ' + esc(match.value.split(' (')[0]) + '</b>');
            }
          }
        });
        if (out.length) {
          result.innerHTML = '<svg class="gd-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm-1.2 14.2-4-4 1.4-1.4 2.6 2.6 5.6-5.6 1.4 1.4-7 7Z"/></svg><div>' + T('product.adv_result', { sizes: out.join(' · ') }) + '</div>';
          result.classList.add('is-visible');
          update(true);
          msg.textContent = '';
        } else { result.classList.remove('is-visible'); }
      }
    }
    /* maattabel-modal: "kies deze maat" */
    $$('[data-gd-pick]', el.ownerDocument).forEach(function (b) {
      b.addEventListener('click', function () {
        var code = b.getAttribute('data-gd-pick'), gi = parseInt(b.getAttribute('data-gd-group'), 10);
        var g = groups[gi]; if (!g) return;
        var match = $$('input', g).filter(function (i) { return sizeCode(i.value) === code; })[0];
        if (match) { match.checked = true; update(true); }
        var m = b.closest('.gd-modal'); if (m) closeModal(m);
      });
    });
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-gd-modal]'); if (!t) return;
    e.preventDefault(); var m = document.getElementById(t.getAttribute('data-gd-modal')); if (m) openModal(m);
  });

  /* ---------------- galerij + lightbox ---------------- */
  function goToSlide(scope, i) {
    var track = $('[data-gd-track]', scope); if (!track) return;
    var slide = track.children[i]; if (!slide) return;
    track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
  }
  $$('[data-gd-gallery]').forEach(function (g) {
    var track = $('[data-gd-track]', g); if (!track) return;
    var dots = $$('[data-gd-dot]', g), thumbs = $$('[data-gd-thumb]', g);
    function mark(i) { dots.concat(thumbs).forEach(function (d) { d.setAttribute('aria-current', parseInt(d.getAttribute('data-i'), 10) === i); }); }
    track.addEventListener('scroll', function () { mark(Math.round(track.scrollLeft / track.clientWidth)); }, { passive: true });
    dots.concat(thumbs).forEach(function (d) { d.addEventListener('click', function () { goToSlide(g, parseInt(d.getAttribute('data-i'), 10)); }); });
    var lb = $('[data-gd-lightbox]', g.closest('[data-gd-product]') || document);
    $$('.gd-gallery__slide', g).forEach(function (s, i) {
      s.addEventListener('click', function () {
        if (!lb) return; openModal(lb);
        var t = $('.gd-lightbox__track', lb); t.scrollLeft = t.clientWidth * i;
      });
    });
  });

  /* ---------------- verkooppunten ---------------- */
  $$('[data-gd-storefinder]').forEach(function (sf) {
    var stores = JSON.parse($('[data-gd-stores-json]', sf).textContent);
    var list = $('[data-gd-store-list]', sf), count = $('[data-gd-store-count]', sf);
    var input = $('[data-gd-store-q]', sf), frame = $('[data-gd-map]', sf), chipsWrap = $('[data-gd-chips]', sf);
    var origin = null, active = null, chain = '', place = '';
    var RADIUS = 10; // km rond de gezochte plaats
    function dist(a, b) {
      var R = 6371, dLat = (b.lat - a.lat) * Math.PI / 180, dLng = (b.lng - a.lng) * Math.PI / 180;
      var x = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(a.lat * Math.PI / 180) * Math.cos(b.lat * Math.PI / 180) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
      return R * 2 * Math.atan2(Math.sqrt(x), Math.sqrt(1 - x));
    }
    function setMap(s) {
      if (!frame) return;
      var pts = s ? [s] : stores.filter(function (x) { return x.lat && x.lng; });
      if (!pts.length) return;
      var lats = pts.map(function (p) { return p.lat; }), lngs = pts.map(function (p) { return p.lng; });
      var pad = s ? 0.012 : 0.25;
      var bbox = [Math.min.apply(0, lngs) - pad, Math.min.apply(0, lats) - pad, Math.max.apply(0, lngs) + pad, Math.max.apply(0, lats) + pad].join(',');
      frame.src = 'https://www.openstreetmap.org/export/embed.html?bbox=' + bbox + '&layer=mapnik' + (s ? '&marker=' + s.lat + ',' + s.lng : '');
    }
function setMapPts(pts) {
  if (!frame || !pts.length) return;
  var lats = pts.map(function (p) { return p.lat; }), lngs = pts.map(function (p) { return p.lng; });
  var pad = 0.04;
  var bbox = [Math.min.apply(0, lngs) - pad, Math.min.apply(0, lats) - pad, Math.max.apply(0, lngs) + pad, Math.max.apply(0, lats) + pad].join(',');
  frame.src = 'https://www.openstreetmap.org/export/embed.html?bbox=' + bbox + '&layer=mapnik';
}
    function render() {
      var q = (input.value || '').trim().toLowerCase();
var rows = stores.map(function (s, i) { s._i = i; s._d = origin && s.lat ? dist(origin, s) : null; return s; })
  .filter(function (s) { return !chain || s.chain === chain; })
  .filter(function (s) { return origin || !q || (s.name + ' ' + s.city + ' ' + s.postcode + ' ' + s.address + ' ' + s.chain).toLowerCase().indexOf(q) !== -1; });
var note = '';
if (origin) {
  rows.sort(function (a, b) { return (a._d == null ? 1e9 : a._d) - (b._d == null ? 1e9 : b._d); });
  var near = rows.filter(function (s) { return s._d != null && s._d <= RADIUS; });
  if (near.length) {
    rows = near;
    count.textContent = T('stores.in_radius', { count: near.length, km: RADIUS, place: place });
  } else {
    // niets binnen 10 km: laat de 3 dichtstbijzijnde zien
    rows = rows.filter(function (s) { return s._d != null; }).slice(0, 3);
    count.textContent = T('stores.none_radius', { km: RADIUS, place: place });
    note = '<li class="gd-sf__empty">' + T('stores.nearest') + '</li>';
  }
} else {
  count.textContent = rows.length + ' ' + (rows.length === 1 ? T('stores.one') : T('stores.many'));
}
if (!rows.length) { list.innerHTML = '<li class="gd-sf__empty">' + T('stores.none') + ' <a href="' + (GD.shopUrl || '/collections/all') + '"><b>' + T('stores.none_link') + '</b></a>.</li>'; return; }
list.innerHTML = note + rows.map(function (s) {
        var full = [s.address, (s.postcode + ' ' + s.city).trim()].filter(Boolean).join(', ');
        var route = 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(s.name + ' ' + full);
        return '<li class="gd-store' + (active === s._i ? ' is-active' : '') + '" data-i="' + s._i + '" tabindex="0">' +
          '<div class="gd-store__name">' + esc(s.name) + '</div>' +
          '<div class="gd-store__dist">' + (s._d != null ? s._d.toFixed(1).replace('.', ',') + ' km' : '') + '</div>' +
          '<div class="gd-store__addr">' + esc(full) + '</div>' +
          (s.tags.length ? '<div class="gd-store__tags">' + s.tags.map(function (t) { return '<span>' + esc(t) + '</span>'; }).join('') + '</div>' : '') +
          '<div class="gd-store__actions"><a href="' + route + '" target="_blank" rel="noopener">' + T('stores.route') + '</a>' +
          (s.phone ? '<a href="tel:' + esc(s.phone.replace(/\s/g, '')) + '">' + T('stores.call') + '</a>' : '') +
          (s.url ? '<a href="' + esc(s.url) + '" target="_blank" rel="noopener">' + T('stores.website') + '</a>' : '') + '</div></li>';
      }).join('');
      // kaart op de gevonden winkels zoomen
      if (origin && active == null) setMapPts(rows.concat([origin]));
    }
    list.addEventListener('click', function (e) {
      if (e.target.closest('a')) return;
      var li = e.target.closest('.gd-store'); if (!li) return;
      active = parseInt(li.getAttribute('data-i'), 10); setMap(stores[active]); render();
      if (window.innerWidth < 990 && frame) frame.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    list.addEventListener('keydown', function (e) { if (e.key === 'Enter' && e.target.classList.contains('gd-store')) e.target.click(); });
    // elke plaats of postcode → coördinaten, dan winkels binnen 10 km.
    // Postcode NL (1234 of 1234 AB): PDOK, de adresdienst van de overheid.
    // Postcode BE (1234): OpenStreetMap. Plaatsnaam: OpenStreetMap, alleen NL/BE.
    var timer = null, seq = 0;
    var NOM = 'https://nominatim.openstreetmap.org/search?format=json&limit=1&accept-language=nl&';
    function viaPdok(pc) {
      return fetch('https://api.pdok.nl/bzk/locatieserver/search/v3_1/free?rows=1&fq=type:postcode&fl=weergavenaam,centroide_ll&q=' + encodeURIComponent(pc))
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var d = j && j.response && j.response.docs && j.response.docs[0];
          var m = d && /POINT\(([\d.]+) ([\d.]+)\)/.exec(d.centroide_ll || '');
          if (!m) return null;
          var city = (/\d{4}[A-Z]{2}\s+(.+)$/.exec(d.weergavenaam || '') || [])[1];
          return { lat: parseFloat(m[2]), lng: parseFloat(m[1]), name: pc.replace(/^(\d{4})([A-Z]{2})$/, '$1 $2') + (city ? ' (' + city + ')' : '') };
        });
    }
    function viaNominatim(params, label) {
      return fetch(NOM + params)
        .then(function (r) { return r.json(); })
        .then(function (j) {
          if (!j || !j[0]) return null;
          var parts = (j[0].display_name || '').split(',').map(function (x) { return x.trim(); });
          var name = label ? label + (parts[1] ? ' (' + parts[1] + ')' : '') : (j[0].name || parts[0]);
          return { lat: parseFloat(j[0].lat), lng: parseFloat(j[0].lon), name: name };
        });
    }
    function locate(q) {
      var my = ++seq, job;
      var pc4 = /^(\d{4})$/.exec(q), pc6 = /^(\d{4})\s?([a-z]{2})$/i.exec(q);
      if (pc6) job = viaPdok(pc6[1] + pc6[2].toUpperCase());
      else if (pc4) {
        // Belgische bezoeker: eerst België, anders eerst Nederland
        var nl = function () { return viaPdok(pc4[1]); }, be = function () { return viaNominatim('countrycodes=be&postalcode=' + pc4[1], pc4[1]); };
        var first = GD.country === 'BE' ? be : nl, second = GD.country === 'BE' ? nl : be;
        job = first().then(function (r) { return r || second(); });
      } else job = viaNominatim('countrycodes=nl,be&featureType=settlement&q=' + encodeURIComponent(q));
      count.textContent = T('stores.searching');
      job.then(function (r) {
        if (my !== seq) return; // er is intussen verder getypt
        origin = r ? { lat: r.lat, lng: r.lng } : null;
        place = r ? r.name : '';
        active = null; render();
      }).catch(function () { if (my === seq) { origin = null; render(); } });
    }
input.addEventListener('input', function () {
  var q = input.value.trim();
  origin = null; active = null; clearTimeout(timer);
  render(); // direct filteren op naam/plaats terwijl je typt
  if (/^\d{4}(\s?[a-z]{2})?$/i.test(q) || (q.length >= 3 && !/^\d+\s?[a-z]?$/i.test(q))) timer = setTimeout(function () { locate(q); }, 700);
  if (!q) setMap(null);
});
$('[data-gd-store-form]', sf).addEventListener('submit', function (e) {
  e.preventDefault();
  var q = input.value.trim(); if (!q) return;
  clearTimeout(timer); locate(q);
});
    var geo = $('[data-gd-geo]', sf);
    if (geo) geo.addEventListener('click', function () {
      if (!navigator.geolocation) return;
      geo.setAttribute('aria-disabled', 'true');
      navigator.geolocation.getCurrentPosition(function (p) {
        origin = { lat: p.coords.latitude, lng: p.coords.longitude }; place = T('stores.your_location'); input.value = ''; active = null; render(); geo.removeAttribute('aria-disabled');
      }, function () { geo.removeAttribute('aria-disabled'); });
    });
    if (chipsWrap) chipsWrap.addEventListener('click', function (e) {
      var c = e.target.closest('[data-chain]'); if (!c) return;
      chain = c.getAttribute('data-chain');
      $$('[data-chain]', chipsWrap).forEach(function (x) { x.setAttribute('aria-current', x === c); });
      render();
    });
    render(); setMap(null);
  });

  /* ---------------- header: staand logo → beeldmerk bij scrollen ---------------- */
  var header = $('.gd-header');
  if (header) {
    var ticking = false;
    var onScroll = function () {
      var y = window.scrollY || 0;
      // marge tegen heen-en-weer springen rond de grens
      if (y > 80) header.classList.add('is-scrolled');
      else if (y < 20) header.classList.remove('is-scrolled');
      ticking = false;
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  /* ---------------- USP-bolletjes: tikken op mobiel, koppeling met lijst ---------------- */
  $$('[data-gd-solve]').forEach(function (sec) {
    function setActive(key) {
      $$('.gd-dot', sec).forEach(function (d) { d.classList.toggle('is-open', d.getAttribute('data-gd-dot-n') === key); });
      $$('[data-gd-dot-li]', sec).forEach(function (li) { li.classList.toggle('is-active', li.getAttribute('data-gd-dot-li') === key); });
    }
    sec.addEventListener('click', function (e) {
      var d = e.target.closest('.gd-dot');
      if (d) { setActive(d.classList.contains('is-open') ? null : d.getAttribute('data-gd-dot-n')); return; }
      var li = e.target.closest('[data-gd-dot-li]');
      if (li) { setActive(li.getAttribute('data-gd-dot-li')); return; }
      setActive(null);
    });
    $$('[data-gd-dot-li]', sec).forEach(function (li) {
      li.addEventListener('mouseenter', function () { setActive(li.getAttribute('data-gd-dot-li')); });
    });
  });

  // taal: bezoekers buiten NL/BE eenmalig naar Engels. Een eigen keuze (footer NL · EN) gaat altijd voor.
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-gd-lang]');
    if (a) { try { document.cookie = 'gd_lang=' + a.getAttribute('data-gd-lang') + ';path=/;max-age=31536000;samesite=lax'; } catch (er) {} }
  });
  (function () {
    var L = GD.lang;
    if (!L || L.current !== 'nl' || !L.en || L.designMode) return;
    try {
      if (/(?:^|; )gd_lang=/.test(document.cookie) || sessionStorage.getItem('gd_geo')) return;
      sessionStorage.setItem('gd_geo', '1');
    } catch (er) { return; }
    if (/bot|crawl|spider|lighthouse/i.test(navigator.userAgent)) return;
    fetch('/browsing_context_suggestions.json?country[enabled]=true', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var c = d && d.detected_values && d.detected_values.country && d.detected_values.country.handle;
        if (c && c !== 'NL' && c !== 'BE') location.replace(L.en + location.search + location.hash);
      })
      .catch(function () {});
  })();

  window.GDCart = { render: renderCart, open: function () { openDrawer('gd-cart'); } };
})();
